import { type AttachmentSelectDto, AttachmentType } from '@@types/api.types';
import { FILE_EXTENSION_BY_CONTENT_TYPE } from '@azymmetric/shared/attachments/attachment.constants';
import { normalizeAttachmentUrl } from '@schemas/attachment.schema';

export const isImageContentType = (contentType?: string): boolean => {
  return Boolean(contentType?.startsWith('image/'));
};

export const downloadFile = (params: { fileName: string; url: string }): void => {
  const { fileName, url } = params;
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
};

export const hasFileExtension = (value: string): boolean => {
  return /\.[a-zA-Z0-9]{1,10}$/.test(value);
};

const resolveFileExtension = (contentType?: string): string | undefined => {
  if (!contentType) {
    return undefined;
  }

  const normalizedContentType = contentType.split(';')[0]?.trim().toLowerCase();
  if (!normalizedContentType) {
    return undefined;
  }

  return FILE_EXTENSION_BY_CONTENT_TYPE[normalizedContentType];
};

export const resolveDownloadFileName = (attachment: AttachmentSelectDto): string => {
  const safeTitle = attachment.title.replaceAll('"', '').trim();
  const fallbackTitle = safeTitle.length > 0 ? safeTitle : 'attachment';

  if (hasFileExtension(fallbackTitle)) {
    return fallbackTitle;
  }

  const extension = resolveFileExtension(attachment.contentType);
  if (!extension) {
    return fallbackTitle;
  }

  return `${fallbackTitle}.${extension}`;
};

export const resolveAttachmentOpenUrl = (attachment: AttachmentSelectDto): string | undefined => {
  if (attachment.type === AttachmentType.URL) {
    return attachment.url ? normalizeAttachmentUrl(attachment.url) : undefined;
  }

  return attachment.inlineUrl ?? attachment.downloadUrl;
};
